<template>
    <div
        v-if="isPartner"
        class="block">
        <div class="font-medium">
            {{ statusLabel }}
        </div>
        <a
            v-if="invitationLink && status === 1"
            class="truncate text-main-500 block cursor-pointer"
            :href="invitationLink"
            target="_blank">
            {{ invitationLink }}
        </a>
        <a
            v-if="status === 1"
            v-loading="inviting"
            class="truncate text-main-500 block cursor-pointer shadow"
            @click="resendInvitation">
            Gửi lại lời mời
        </a>
    </div>
</template>

<script setup lang="ts">
const props = defineProps({
  params: {
    type: Object as PropType<any>,
    required: true
  }
})

const { params } = toRefs(props)
const paramData = computed(() => params.value.data)
const userId = computed(() => paramData.value?._id)
const invitationBy = computed(() => paramData.value?.invitationBy || paramData.value?.registerBy)
const inviting = ref(false)

const isPartner = computed(() => {
  const types = paramData.value?.type || []
  if (types.includes('PARTNER')) {
    return true
  }

  return false
})

const invitationLink = computed(() => {
  return paramData.value?.invitationLink
})

const resendInvitation = () => {
  inviting.value = true
  $api($urlPartner.partner.resendActivation, { uriParams: { ID: userId.value } })
    .then((data) => {
      const resData: any = data?.data?.value

      if (resData?.success) {
        paramData.value.invitationLink = resData.data.invitationLink
      }

      inviting.value = false
    })
    .catch(() => {
      inviting.value = false
    })
}

const status = computed(() => {
  if (!paramData.value?.sentInviteJoinSystem) {
    return 0 // chưa mời
  }

  if (!paramData.value?.invitationStatus) {
    return 1 // đã gửi
  }

  return 2 // đã tham giã
})

const statusLabel = computed(() => {
  if (status.value === 0) {
    return 'Chưa mời'
  }
  if (status.value === 1) {
    return 'Chờ xác nhận'
  }

  return 'Đã tham gia'
})
</script>
